import script from "./EmailTemplates.vue?vue&type=script&setup=true&lang=js"
export * from "./EmailTemplates.vue?vue&type=script&setup=true&lang=js"

import "./EmailTemplates.vue?vue&type=style&index=0&id=b7e3cb16&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jhunr\\Documents\\Work\\GCM3\\repos\\talentsage2025-january\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b7e3cb16"]])

export default __exports__